import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './i18n';
import './local';

import './portal.css';

const win: any = window;
!!!win["lang"] && (win["lang"] = "en");
document.documentElement.lang = win["lang"];
!!!win['googleMapKey'] && (win['googleMapKey'] = "AIzaSyDtKbJ8frTCqg4LsSfO0GDPla_tmaO5Pmg");

const lang = win['lang']
const rtl = lang === 'ar';

ReactDOM.render(
  <React.StrictMode >
    <App rtl={rtl} />
  </React.StrictMode>,
  document.getElementById('root')
);

